export function preferencesSettingsJson (language) {
  let items

  if (language === 'es') {
    items = {
      times: { // tiempo de conexión y tiempo de persistencia
        name: 'times',
        label: 'editar tiempos de conexión y de persistencia'
      },
      locations: { // otros tipos de ubicaciones, ubicación de google, tiempo de ubicaciones
        name: 'locations',
        label: 'editar configuraciones de ubicaciones'
      },
      reports: {
        name: 'reports',
        label: 'recibir los reportes de aplicaciones y estadísticas'
      }
    }
  } else if (language === 'en') {
    items = {
      times: { // tiempo de conexión y tiempo de persistencia
        name: 'times',
        label: 'edit connection and persistence timess'
      },
      locations: { // otros tipos de ubicaciones, ubicación de google, tiempo de ubicaciones
        name: 'locations',
        label: 'edit location settings'
      },
      reports: {
        name: 'reports',
        label: 'receive apps reports and statistics'
      }
    }
  }
  return (items)
}
